<template>
  <div
    class="case-item-exhibition-thumb3-pc"
    @click.stop="navigateTo('/case/info?id='+info.id)"
  >
    <div class="pic">
      <pic-pc :src="info.pic" />
    </div>
    <div class="info">
      <div class="title line-1">
        {{ $t2(lang, info.title || '', info.en_title || '') }}
      </div>
      <div class="summary line-3">
        {{ $t2(lang, replaceHtmlTag(info.content || ''), replaceHtmlTag(info.en_content || '')) }}
      </div>
    </div>
  </div>
</template>

<script>

import {mapState} from "vuex";
import PicPc from "../../../common/Pic";

export default {
  name: 'CaseItemExhibitionThumb3Pc',
  components: {PicPc},
  props: {
    info: {
      type: Object,
      default: () => {}
    }
  },
  computed: {
    ...mapState(['browser', 'lang']),
  },
}
</script>

<style scoped lang="scss">
.case-item-exhibition-thumb3-pc {
  cursor: pointer;
  .pic{
    width: 100%;
    height: 480px;
  }
  &:hover{
    .info{
      .title{
        color: #D80C1E;
      }
    }
  }
  .info{
    margin-top: 20px;
    .title{
      height: 22px;
      font-size: 20px;
      font-weight: bold;
      color: #343434;
      line-height: 22px;
    }
    .summary{
      font-size: 14px;
      margin-top: 24px;
      line-height: 24px;
      color: #666666;
      height: 72px;
    }
  }
}
</style>
